var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    attrs: { buttons: _vm.more.buttons, parameters: _vm.parameters },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Informations financières")) +
                "\n    "
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "relative mt-3" },
                  [_c("preloader", { attrs: { display: _vm.isLoading } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.financialActivity && _vm.financialActivity.length > 0
              ? _c(
                  "div",
                  [
                    !_vm.isLoading
                      ? _c(
                          "el-table",
                          { attrs: { data: _vm.financialActivityFormatted } },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "publication_year",
                                label: _vm.$t.__("common.labels.year")
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "publication_date",
                                label: _vm.$t.__(
                                  "overview.tabs.TabFinancialActivityThird.publication_date"
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "turnover",
                                label: _vm.$t.__(
                                  "overview.tabs.TabFinancialActivityThird.turnover"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", {
                                          class: scope.row.turnover_trend
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.numberFormatCurrency(
                                                scope.row.turnover
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3733873000
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "income",
                                label: _vm.$t.__(
                                  "overview.tabs.TabFinancialActivityThird.profit"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", {
                                          class: scope.row.income_trend
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$filters.numberFormatCurrency(
                                                scope.row.income
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2260502760
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "workforce_count",
                                label: _vm.$t.__(
                                  "overview.tabs.TabFinancialActivityThird.effective"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", {
                                          class: scope.row.workforce_count_trend
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.workforce_count)
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4187394295
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _c("div", [
                  !_vm.isLoading
                    ? _c("div", { staticClass: "placeholder" }, [
                        _c("p", [_vm._v(_vm._s(_vm.placeholder))])
                      ])
                    : _vm._e()
                ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }